/**
 * ewc-cart — gaveta de carrinho independente de tema.
 *
 * Painel próprio, montado a partir do /cart.js. Não depende de seção do tema, de
 * re-render por "sections", nem da marcação da gaveta nativa (que fica escondida).
 * O único contato com o tema é o ADAPTADOR: o que abre a gaveta (link/ícone do
 * carrinho e formulário de compra) e onde fica o contador de itens. Tudo com
 * detecção automática e escape manual pela config.
 *
 * Falha aberto: qualquer erro deixa o tema funcionando como antes.
 */
(function () {
  'use strict';
  if (window.EwcCart) return;

  var PADRAO = {
    textos: {
      titulo: 'Your Cart', vazio: 'Your cart is empty', anuncio: '', recompensa_antes: 'Only {{restante}} away from a {{brinde}}',
      recompensa_depois: 'You got a {{brinde}}!', economia: 'You Save', subtotal: 'Subtotal', checkout: 'CHECKOUT →',
      remover: 'Remove', upsell_titulo: 'Add More & Save More', upsell_adicionar: 'Add', garantia: '', so_upsell: 'Add a product to check out', gratis: 'FREE',
      economia_item: 'You save {{valor}}', cupom_marcador: 'Discount code', cupom_aplicar: 'Apply', cupom_erro: 'Code not valid',
      anuncio_depois: '', descontos_rotulo: 'Discounts', continuar: ''
    },
    cores: { destaque: '#111111', fundo: '#ffffff', texto: '#111111', recompensa: '#ecb4cc',
             anuncio_fundo: '', anuncio_texto: '', selo_fundo: '', selo_texto: '',
             checkout_fundo: '', checkout_texto: '', desconto_fundo: '', desconto_texto: '' },
    largura: 440, raio: 10, timer_segundos: 0, imagem_cabecalho: '', imagem_altura: 65,
    brinde: null, upsells: [], selos: [], alternador: null,
    modulos: { anuncio: true, recompensas: true, upsells: true, selos: true, gate_so_upsell: true, economia: true,
               cupom: false, descontos: false, alternador: false, expresso: false, pagamentos: false,
               selo_pacote: true, selo_economia: true },
    adaptador: { gatilhos: '', contadores: '', gaveta_nativa: '', ignorar_formularios: '', abrir_ao_adicionar: true }
  };

  var SEL = {
    gatilhos: 'a[href$="/cart"],a[href*="/cart?"],a[href$="/cart/"],[data-cart-drawer-toggle],[data-cart-toggle],cart-drawer-toggle,' +
              '#cart-icon-bubble,.header__icon--cart,.cart-icon,.js-drawer-open-cart,[aria-controls="cart-drawer"],[aria-controls="CartDrawer"],[data-action="open-cart"]',
    contadores: '.cart-count-bubble span[aria-hidden],.cart-count-bubble span:not(.visually-hidden),[data-cart-count],.cart-count,.cart-item-count,' +
                '.header__cart-count,.cart-link__bubble-num,.site-header__cart-count span,[data-header-cart-count]',
    gaveta_nativa: 'cart-drawer,#CartDrawer,.cart-drawer,#cart-drawer,#shopify-section-cart-drawer,.drawer--cart,[data-cart-drawer],.mini-cart,#mini-cart,' +
                   '.cart-popup,cart-notification,#cart-notification,.cart-notification,.upcart-cart'
  };

  var cfg, raiz, refs = {}, carrinho = null, aberto = false, ocupado = false, relogio = null, cacheProduto = {}, produtoPronto = {};

  /* ------------------------------------------------------------ util */
  function juntar(base, extra) {
    var s = {};
    Object.keys(base).forEach(function (k) { s[k] = base[k]; });
    Object.keys(extra || {}).forEach(function (k) {
      if (extra[k] && typeof extra[k] === 'object' && !Array.isArray(extra[k]) && base[k] && typeof base[k] === 'object')
        s[k] = juntar(base[k], extra[k]);
      else if (extra[k] !== undefined && extra[k] !== null) s[k] = extra[k];
    });
    return s;
  }
  function lerConfig() {
    var no = document.querySelector('[data-ewc-cart-config]');
    var bruto = {};
    try { bruto = JSON.parse(no ? no.textContent : '{}'); } catch (e) { bruto = {}; }
    var c = juntar(PADRAO, bruto.config || {});
    c.moneyFormat = bruto.moneyFormat || '${{amount}}';
    c.rotas = bruto.rotas || {};
    var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || c.rotas.raiz || '/';
    c.raiz = root.replace(/\/?$/, '/');
    return c;
  }
  function dinheiro(centavos) {
    var f = cfg.moneyFormat, v = (centavos / 100).toFixed(2), p = v.split('.');
    var inteiro = p[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    return f.replace(/\{\{\s*amount\s*\}\}/g, inteiro + '.' + p[1])
            .replace(/\{\{\s*amount_no_decimals\s*\}\}/g, inteiro)
            .replace(/\{\{\s*amount_with_comma_separator\s*\}\}/g, inteiro.replace(/,/g, '.') + ',' + p[1])
            .replace(/\{\{\s*amount_no_decimals_with_comma_separator\s*\}\}/g, inteiro.replace(/,/g, '.'))
            .replace(/<[^>]*>/g, '');
  }
  function el(tag, classe, texto) {
    var n = document.createElement(tag);
    if (classe) n.className = classe;
    if (texto != null) n.textContent = texto;
    return n;
  }
  function tpl(texto, vars) {
    return String(texto || '').replace(/\{\{\s*(\w+)\s*\}\}/g, function (_, k) { return vars[k] != null ? vars[k] : ''; });
  }
  function ehBrinde(item) { return !!(item.properties && item.properties._ewc_gift) || (cfg.brinde && String(item.variant_id) === String(cfg.brinde.variante_id)); }
  function ehUpsell(item) { return !!(item.properties && (item.properties._ewc_upsell || item.properties.__upsell)); }
  function principais(c) { return c.items.filter(function (i) { return !ehBrinde(i) && !ehUpsell(i); }); }

  /* ------------------------------------------------------------ api */
  function pedir(rota, opts) {
    return fetch(cfg.raiz + rota, opts).then(function (r) {
      if (!r.ok) throw new Error(rota + ' ' + r.status);
      return r.json();
    });
  }
  var api = {
    carrinho: function () { return pedir('cart.js', { headers: { Accept: 'application/json' } }); },
    add: function (itens) {
      return pedir('cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ items: itens }) });
    },
    change: function (chave, qtd) {
      return pedir('cart/change.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ id: chave, quantity: qtd }) });
    },
    produto: function (handle) {
      if (cacheProduto[handle]) return cacheProduto[handle];
      cacheProduto[handle] = pedir('products/' + handle + '.js')
        .then(function (p) { if (p) produtoPronto[handle] = p; return p; })
        .catch(function () { delete cacheProduto[handle]; return null; });
      return cacheProduto[handle];
    }
  };

  /* ------------------------------------------------------------ montagem */
  function montar() {
    raiz.innerHTML = '';
    raiz.style.setProperty('--ewc-acento', cfg.cores.destaque);
    raiz.style.setProperty('--ewc-fundo', cfg.cores.fundo);
    raiz.style.setProperty('--ewc-texto', cfg.cores.texto);
    raiz.style.setProperty('--ewc-recompensa', cfg.cores.recompensa);
    raiz.style.setProperty('--ewc-largura', cfg.largura + 'px');
    raiz.style.setProperty('--ewc-raio', cfg.raio + 'px');
    var extras = { anuncio_fundo: '--ewc-anuncio-fundo', anuncio_texto: '--ewc-anuncio-texto',
                   selo_fundo: '--ewc-selo-fundo', selo_texto: '--ewc-selo-texto',
                   checkout_fundo: '--ewc-checkout-fundo', checkout_texto: '--ewc-checkout-texto',
                   desconto_fundo: '--ewc-desconto-fundo', desconto_texto: '--ewc-desconto-texto' };
    Object.keys(extras).forEach(function (k) { if (cfg.cores[k]) raiz.style.setProperty(extras[k], cfg.cores[k]); });
    if (cfg.fonte) raiz.style.setProperty('--ewc-fonte', cfg.fonte);

    var fundo = el('div', 'ewc-cart__fundo'); fundo.addEventListener('click', fechar);
    var painel = el('aside', 'ewc-cart__painel'); painel.setAttribute('role', 'dialog'); painel.setAttribute('aria-modal', 'true');

    var topo = el('div', 'ewc-cart__topo');
    if (cfg.imagem_cabecalho) {
      topo.classList.add('ewc-cart__topo--centro');
      refs.titulo = el('img', 'ewc-cart__logo');
      refs.titulo.src = cfg.imagem_cabecalho;
      refs.titulo.style.maxHeight = (cfg.imagem_altura || 65) + 'px';
    } else {
      refs.titulo = el('h2', 'ewc-cart__titulo', cfg.textos.titulo);
    }
    var fecharBtn = el('button', 'ewc-cart__fechar'); fecharBtn.type = 'button'; fecharBtn.setAttribute('aria-label', 'Close');
    fecharBtn.innerHTML = '<svg viewBox="0 0 20 20" fill="none" stroke="currentColor" stroke-width="2"><path d="M4 4l12 12M16 4L4 16"/></svg>';
    fecharBtn.addEventListener('click', fechar);
    topo.appendChild(refs.titulo); topo.appendChild(fecharBtn);

    refs.anuncio = el('div', 'ewc-cart__anuncio'); refs.anuncio.hidden = true;
    refs.anuncioTexto = el('span', null, cfg.textos.anuncio); refs.timer = el('span', 'ewc-cart__timer');
    refs.anuncio.appendChild(refs.anuncioTexto); refs.anuncio.appendChild(refs.timer);
    if (cfg.textos.anuncio_depois) refs.anuncio.appendChild(el('span', null, cfg.textos.anuncio_depois));

    refs.recompensas = el('div', 'ewc-cart__recompensas'); refs.recompensas.hidden = true;
    refs.recompensaMsg = el('p', 'ewc-cart__recompensas-msg');
    var trilho = el('div', 'ewc-cart__trilho'); refs.preench = el('div', 'ewc-cart__preenchimento');
    var marco = el('div', 'ewc-cart__marco'); refs.marcoIcone = el('div', 'ewc-cart__marco-icone');
    refs.marcoIcone.innerHTML = '<svg viewBox="0 0 20 20" fill="currentColor"><path d="M3 8h14v9H3zM2 5h16v3H2zM10 5v12M7 5c-1.5 0-2.5-1-2.5-2S5.5 1 7 1s3 2 3 4M13 5c1.5 0 2.5-1 2.5-2S14.5 1 13 1s-3 2-3 4"/></svg>';
    refs.marcoRotulo = el('div', 'ewc-cart__marco-rotulo', cfg.brinde ? cfg.brinde.rotulo : '');
    marco.appendChild(refs.marcoIcone); marco.appendChild(refs.marcoRotulo);
    trilho.appendChild(refs.preench); trilho.appendChild(marco);
    refs.recompensas.appendChild(refs.recompensaMsg); refs.recompensas.appendChild(trilho);

    refs.corpo = el('div', 'ewc-cart__corpo');
    refs.itens = el('div', 'ewc-cart__itens');
    refs.upsells = el('div', 'ewc-cart__upsells'); refs.upsells.hidden = true;
    refs.corpo.appendChild(refs.itens); refs.corpo.appendChild(refs.upsells);

    var rodape = el('div', 'ewc-cart__rodape');

    // alternador (proteção de envio): produto que entra e sai por uma chave liga-desliga
    refs.alternador = el('label', 'ewc-cart__alternador'); refs.alternador.hidden = true;
    rodape.appendChild(refs.alternador);

    // cupom
    refs.cupom = el('form', 'ewc-cart__cupom'); refs.cupom.hidden = !cfg.modulos.cupom;
    refs.cupomInput = el('input', 'ewc-cart__cupom-campo');
    refs.cupomInput.type = 'text'; refs.cupomInput.placeholder = cfg.textos.cupom_marcador; refs.cupomInput.name = 'discount';
    var aplicar = el('button', 'ewc-cart__cupom-btn', cfg.textos.cupom_aplicar); aplicar.type = 'submit';
    refs.cupom.appendChild(refs.cupomInput); refs.cupom.appendChild(aplicar);
    refs.cupom.addEventListener('submit', function (ev) { ev.preventDefault(); aplicarCupom(); });
    rodape.appendChild(refs.cupom);

    // descontos já valendo no carrinho
    refs.descontos = el('div', 'ewc-cart__descontos'); refs.descontos.hidden = true;
    rodape.appendChild(refs.descontos);

    refs.economia = el('div', 'ewc-cart__economia'); refs.economia.hidden = true;
    refs.economia.appendChild(el('span', null, cfg.textos.economia)); refs.economiaValor = el('span'); refs.economia.appendChild(refs.economiaValor);
    var subtotal = el('div', 'ewc-cart__subtotal'); subtotal.appendChild(el('span', null, cfg.textos.subtotal)); refs.subtotal = el('span'); subtotal.appendChild(refs.subtotal);
    refs.aviso = el('div', 'ewc-cart__aviso', cfg.textos.so_upsell); refs.aviso.hidden = true;
    refs.checkout = el('a', 'ewc-cart__checkout', cfg.textos.checkout); refs.checkout.href = cfg.raiz + 'checkout';
    refs.checkout.addEventListener('click', function (ev) { if (refs.checkout.classList.contains('is-disabled')) ev.preventDefault(); });
    rodape.appendChild(refs.economia); rodape.appendChild(subtotal); rodape.appendChild(refs.aviso); rodape.appendChild(refs.checkout);

    // botões de pagamento expresso e ícones: markup nativo, gerado pelo Liquid e clonado aqui
    if (cfg.modulos.expresso) {
      var molde = document.querySelector('template[data-ewc-cart-expresso]');
      if (molde) { var cx = el('div', 'ewc-cart__expresso'); cx.appendChild(molde.content.cloneNode(true)); rodape.appendChild(cx); }
    }
    if (cfg.modulos.pagamentos) {
      var moldeP = document.querySelector('template[data-ewc-cart-pagamentos]');
      if (moldeP) { var px = el('div', 'ewc-cart__pagamentos'); px.appendChild(moldeP.content.cloneNode(true)); rodape.appendChild(px); }
    }
    if (cfg.textos.garantia) rodape.appendChild(el('p', 'ewc-cart__garantia', cfg.textos.garantia));
    if (cfg.textos.continuar) {
      var cont = el('button', 'ewc-cart__continuar', cfg.textos.continuar);
      cont.type = 'button'; cont.addEventListener('click', fechar);
      rodape.appendChild(cont);
    }
    if (cfg.modulos.selos && cfg.selos && cfg.selos.length) {
      var selos = el('div', 'ewc-cart__selos');
      cfg.selos.forEach(function (nome) {
        var svg = document.querySelector('template[data-ewc-selo="' + nome + '"]');
        if (svg) selos.appendChild(svg.content.cloneNode(true));
        else { var chip = el('span', 'ewc-cart__chip', String(nome).replace(/_/g, ' ').toUpperCase()); chip.style.background = '#eee'; chip.style.color = '#333'; selos.appendChild(chip); }
      });
      rodape.appendChild(selos);
    }

    painel.appendChild(topo); painel.appendChild(refs.anuncio); painel.appendChild(refs.recompensas);
    painel.appendChild(refs.corpo); painel.appendChild(rodape);
    raiz.appendChild(fundo); raiz.appendChild(painel);

    raiz.addEventListener('click', function (ev) {
      var b = ev.target.closest && ev.target.closest('[data-ewc-acao]');
      if (!b) return;
      var acao = b.getAttribute('data-ewc-acao'), chave = b.getAttribute('data-ewc-chave'), qtd = parseInt(b.getAttribute('data-ewc-qtd') || '0', 10);
      if (acao === 'mais') mudar(chave, qtd + 1);
      else if (acao === 'menos') mudar(chave, Math.max(0, qtd - 1));
      else if (acao === 'remover') mudar(chave, 0);
      else if (acao === 'upsell') adicionarUpsell(b);
    });
    document.addEventListener('keydown', function (ev) { if (ev.key === 'Escape' && aberto) fechar(); });
  }

  /* ------------------------------------------------------------ render */
  function render(c) {
    carrinho = c;
    var vazio = !c.items.length;
    renderItens(c);

    var rotuloTopo = cfg.textos.titulo + (c.item_count ? ' • ' + c.item_count : '');
    if (refs.titulo.tagName === 'IMG') refs.titulo.alt = rotuloTopo;
    else refs.titulo.textContent = rotuloTopo;
    refs.anuncio.hidden = !(cfg.modulos.anuncio && cfg.textos.anuncio && !vazio);
    if (!refs.anuncio.hidden) ligarTimer();

    if (cfg.modulos.recompensas && cfg.brinde && cfg.brinde.limiar) {
      refs.recompensas.hidden = vazio;
      var limiar = Math.round(cfg.brinde.limiar * 100);
      var total = principais(c).reduce(function (s, i) { return s + i.final_line_price; }, 0);
      var pct = Math.min(100, total / limiar * 100);
      refs.preench.style.width = pct.toFixed(2) + '%';
      var chegou = total >= limiar;
      refs.marcoIcone.classList.toggle('is-complete', chegou);
      refs.recompensaMsg.innerHTML = chegou ? tpl(cfg.textos.recompensa_depois, { brinde: '<strong>' + cfg.brinde.rotulo + '</strong>' })
        : tpl(cfg.textos.recompensa_antes, { restante: '<strong>' + dinheiro(limiar - total) + '</strong>', brinde: '<strong>' + cfg.brinde.rotulo + '</strong>' });
    } else refs.recompensas.hidden = true;

    c.items.forEach(function (i) {
      if (i.handle && !cacheProduto[i.handle]) api.produto(i.handle).then(function () {
        if (carrinho !== c) return;
        atualizarEconomia(c);
        renderItens(c);            // o selo "You save" só existe depois que o compare-at chega
        renderAlternador(c);
      });
    });
    var economia = c.items.reduce(function (s, i) { return s + (i.original_line_price - i.final_line_price); }, 0) + compareAt(c);
    refs.economia.hidden = !(cfg.modulos.economia && economia > 0);
    refs.economiaValor.textContent = '-' + dinheiro(economia);
    refs.subtotal.textContent = dinheiro(c.total_price);
    refs.checkout.textContent = tpl(cfg.textos.checkout, { total: dinheiro(c.total_price) });
    renderDescontos(c);
    renderAlternador(c);

    var soAcessorio = c.item_count > 0 && principais(c).length === 0 && cfg.modulos.gate_so_upsell;
    refs.checkout.classList.toggle('is-disabled', vazio || soAcessorio);
    refs.aviso.hidden = !soAcessorio;

    renderUpsells(c);
    atualizarContadores(c.item_count);
    brindeAutomatico(c);
    document.dispatchEvent(new CustomEvent('ewc:cart:updated', { detail: { cart: c } }));
  }
  function renderItens(c) {
    refs.itens.innerHTML = '';
    if (!c.items.length) { refs.itens.appendChild(el('div', 'ewc-cart__vazio', cfg.textos.vazio)); return; }
    var extras = [], base = [];
    c.items.forEach(function (i) { (ehBrinde(i) || ehUpsell(i) ? extras : base).push(i); });
    base.concat(extras).forEach(function (item) { refs.itens.appendChild(linha(item)); });
  }
  function atualizarEconomia(c) {
    var economia = c.items.reduce(function (s, i) { return s + (i.original_line_price - i.final_line_price); }, 0) + compareAt(c);
    refs.economia.hidden = !(cfg.modulos.economia && economia > 0);
    refs.economiaValor.textContent = '-' + dinheiro(economia);
  }
  function compareAt(c) {
    // economia contra o preço de tabela, quando o produto tem compare-at (lido do /products/x.js já em cache)
    var soma = 0;
    c.items.forEach(function (i) {
      var p = produtoPronto[i.handle];
      if (!p) return;
      var v = (p.variants || []).filter(function (x) { return x.id === i.variant_id; })[0];
      if (v && v.compare_at_price > i.original_price) soma += (v.compare_at_price - i.original_price) * i.quantity;
    });
    return soma;
  }
  /* Selo verde da referência: marca de conferido + texto, fundo e tinta próprios. */
  function selo(texto) {
    var s = el('span', 'ewc-cart__selo-verde');
    s.innerHTML = '<svg viewBox="0 0 20 20" fill="none" aria-hidden="true"><path d="M4 10.5l4 4 8-9" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round"/></svg>';
    s.appendChild(el('span', null, texto));
    return s;
  }

  /* Preço de tabela da linha: o compare-at do produto quando existe, senão o preço cheio. */
  function precoCheio(item) {
    var p = produtoPronto[item.handle];
    if (p) {
      var v = (p.variants || []).filter(function (x) { return x.id === item.variant_id; })[0];
      if (v && v.compare_at_price > item.original_price) return v.compare_at_price * item.quantity;
    }
    return item.original_line_price;
  }

  function linha(item) {
    var brinde = ehBrinde(item) || item.final_line_price === 0;
    var extra = brinde || ehUpsell(item);
    var n = el('div', 'ewc-cart__item' + (extra ? ' ewc-cart__item--extra' : ''));

    var img = el('img', 'ewc-cart__img');
    if (item.image) img.src = item.image.replace(/(\.[a-z]+)(\?.*)?$/i, '_180x180$1$2');
    img.alt = ''; img.loading = 'lazy';

    /* Duas colunas, como na referência: à esquerda nome, selos, opções e quantidade;
       à direita os preços, o selo de economia e a lixeira. */
    var esq = el('div', 'ewc-cart__col-esq');
    var dir = el('div', 'ewc-cart__col-dir');

    var nome = el('h3', 'ewc-cart__nome');
    var a = el('a', null, (item.quantity > 1 ? item.quantity + 'x ' : '') + item.product_title);
    a.href = item.url; nome.appendChild(a); esq.appendChild(nome);

    if (item.variant_title && item.variant_title !== 'Default Title') esq.appendChild(el('p', 'ewc-cart__variante', item.variant_title));
    Object.keys(item.properties || {}).forEach(function (k) {
      if (k.charAt(0) !== '_' && item.properties[k]) esq.appendChild(el('p', 'ewc-cart__variante', k + ': ' + item.properties[k]));
    });

    /* Um selo por oferta. O título do desconto costuma repetir a marca do pacote —
       mostrar os dois deixa a linha com a mesma etiqueta duas vezes. */
    var chips = el('div', 'ewc-cart__chips'), vistos = {};
    function chip(texto) {
      if (!texto || vistos[texto]) return;
      vistos[texto] = 1; chips.appendChild(selo(texto));
    }
    if (cfg.modulos.selo_pacote && item.properties && item.properties._ewc_bundle) chip(item.properties._ewc_bundle);
    (item.line_level_discount_allocations || []).forEach(function (al) {
      chip(al.discount_application && al.discount_application.title);
    });
    if (chips.childNodes.length) esq.appendChild(chips);

    if (!brinde) {
      var q = el('div', 'ewc-cart__qtd');
      var menos = el('button', null, '−'); menos.type = 'button';
      menos.setAttribute('data-ewc-acao', 'menos'); menos.setAttribute('data-ewc-chave', item.key); menos.setAttribute('data-ewc-qtd', item.quantity);
      var mais = el('button', null, '+'); mais.type = 'button';
      mais.setAttribute('data-ewc-acao', 'mais'); mais.setAttribute('data-ewc-chave', item.key); mais.setAttribute('data-ewc-qtd', item.quantity);
      q.appendChild(menos); q.appendChild(el('span', null, String(item.quantity))); q.appendChild(mais);
      esq.appendChild(q);
    }

    var cheio = precoCheio(item);
    var precos = el('div', 'ewc-cart__preco');
    if (cheio > item.final_line_price) precos.appendChild(el('span', 'ewc-cart__riscado', dinheiro(cheio)));
    precos.appendChild(el('span', 'ewc-cart__preco-final', brinde && item.final_line_price === 0 ? cfg.textos.gratis : dinheiro(item.final_line_price)));
    dir.appendChild(precos);
    if (cfg.modulos.selo_economia && cheio > item.final_line_price) {
      var eco = el('div', 'ewc-cart__chips');
      eco.appendChild(selo(tpl(cfg.textos.economia_item, { valor: dinheiro(cheio - item.final_line_price) })));
      dir.appendChild(eco);
    }
    var rem = el('button', 'ewc-cart__remover'); rem.type = 'button';
    rem.setAttribute('aria-label', cfg.textos.remover);
    rem.setAttribute('data-ewc-acao', 'remover'); rem.setAttribute('data-ewc-chave', item.key);
    rem.innerHTML = '<svg viewBox="0 0 24 24" fill="none" aria-hidden="true"><path d="M4 7h16M10 11v6M14 11v6M6 7l1 13a1 1 0 0 0 1 1h8a1 1 0 0 0 1-1l1-13M9 7V4h6v3" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"/></svg>';
    dir.appendChild(rem);

    var meio = el('div', 'ewc-cart__info');
    meio.appendChild(esq); meio.appendChild(dir);
    n.appendChild(img); n.appendChild(meio);
    return n;
  }

  function renderUpsells(c) {
    if (!cfg.modulos.upsells || !cfg.upsells || !cfg.upsells.length || !c.items.length) { refs.upsells.hidden = true; return; }
    var noCarrinho = {}; c.items.forEach(function (i) { noCarrinho[i.handle] = true; });
    var candidatos = cfg.upsells.filter(function (u) {
      if (noCarrinho[u.handle]) return false;
      if (u.gatilho_handles && u.gatilho_handles.length) return u.gatilho_handles.some(function (h) { return noCarrinho[h]; });
      return true;
    });
    if (!candidatos.length) { refs.upsells.hidden = true; return; }
    refs.upsells.hidden = false; refs.upsells.innerHTML = '';
    refs.upsells.appendChild(el('p', 'ewc-cart__upsells-titulo', cfg.textos.upsell_titulo));
    candidatos.forEach(function (u) {
      var tile = el('div', 'ewc-cart__upsell'); tile.setAttribute('data-ewc-upsell', u.handle);
      refs.upsells.appendChild(tile);
      api.produto(u.handle).then(function (p) {
        if (!p) { tile.remove(); return; }
        var img = el('img'); img.src = (p.featured_image || '').replace(/(\.[a-z]+)(\?.*)?$/i, '_120x120$1$2'); img.alt = '';
        var info = el('div', 'ewc-cart__upsell-info'); info.appendChild(el('strong', null, p.title));
        var v0 = p.variants.filter(function (v) { return v.available; })[0] || p.variants[0];
        var precoTxt = el('span'); precoTxt.innerHTML = (v0.compare_at_price > v0.price ? '<span class="ewc-cart__riscado">' + dinheiro(v0.compare_at_price) + '</span>' : '') + dinheiro(v0.price);
        info.appendChild(precoTxt);
        var sel = null;
        if (p.variants.length > 1) {
          sel = el('select');
          p.variants.forEach(function (v) { var o = el('option', null, v.title); o.value = v.id; o.disabled = !v.available; sel.appendChild(o); });
          sel.value = String(v0.id);
          sel.addEventListener('change', function () { var v = p.variants.filter(function (x) { return String(x.id) === sel.value; })[0]; if (v) precoTxt.innerHTML = (v.compare_at_price > v.price ? '<span class="ewc-cart__riscado">' + dinheiro(v.compare_at_price) + '</span>' : '') + dinheiro(v.price); });
          info.appendChild(sel);
        }
        var btn = el('button', 'ewc-cart__upsell-add', cfg.textos.upsell_adicionar); btn.type = 'button';
        btn.setAttribute('data-ewc-acao', 'upsell'); btn.setAttribute('data-ewc-variante', String(v0.id));
        if (sel) sel.addEventListener('change', function () { btn.setAttribute('data-ewc-variante', sel.value); });
        tile.appendChild(img); tile.appendChild(info); tile.appendChild(btn);
      });
    });
  }

  /* Descontos já aplicados: um selo com o título e o valor, como na referência. */
  function renderDescontos(c) {
    if (!cfg.modulos.descontos) { refs.descontos.hidden = true; return; }
    var linhas = [];
    (c.cart_level_discount_applications || []).forEach(function (a) {
      linhas.push({ titulo: a.title, valor: a.total_allocated_amount });
    });
    var porTitulo = {};
    c.items.forEach(function (i) {
      (i.line_level_discount_allocations || []).forEach(function (al) {
        var d = al.discount_application || {};
        if (!d.title) return;
        porTitulo[d.title] = (porTitulo[d.title] || 0) + al.amount;
      });
    });
    Object.keys(porTitulo).forEach(function (k) { linhas.push({ titulo: k, valor: porTitulo[k] }); });
    refs.descontos.innerHTML = '';
    refs.descontos.hidden = !linhas.length;
    if (linhas.length && cfg.textos.descontos_rotulo) refs.descontos.appendChild(el('span', 'ewc-cart__descontos-rotulo', cfg.textos.descontos_rotulo));
    linhas.forEach(function (l) {
      var n = el('div', 'ewc-cart__desconto');
      var etiqueta = el('span', 'ewc-cart__desconto-etiqueta');
      etiqueta.innerHTML = '<svg viewBox="0 0 20 20" fill="none" aria-hidden="true"><path d="M10.5 2.5H16a1.5 1.5 0 0 1 1.5 1.5v5.5L9 18 2 11l8.5-8.5Z" stroke="currentColor" stroke-width="1.5" stroke-linejoin="round"/><circle cx="13.5" cy="6.5" r="1.2" fill="currentColor"/></svg>';
      etiqueta.appendChild(el('span', null, l.titulo));
      n.appendChild(etiqueta);
      n.appendChild(el('span', 'ewc-cart__desconto-valor', '-' + dinheiro(l.valor)));
      refs.descontos.appendChild(n);
    });
  }

  /* Alternador: um produto que entra e sai do carrinho por uma chave liga-desliga. */
  function renderAlternador(c) {
    var a = cfg.alternador;
    if (!cfg.modulos.alternador || !a || !a.variante_id || !c.items.length) { refs.alternador.hidden = true; return; }
    var linhaA = c.items.filter(function (i) { return String(i.variant_id) === String(a.variante_id); })[0];
    refs.alternador.hidden = false;
    refs.alternador.innerHTML = '';
    var imgA = a.imagem;
    if (!imgA && a.handle) {
      var pi = produtoPronto[a.handle];
      if (pi && pi.featured_image) imgA = pi.featured_image.replace(/(\.[a-z]+)(\?.*)?$/i, '_120x120$1$2');
    }
    if (imgA) { var im = el('img', 'ewc-cart__alternador-img'); im.src = imgA; im.alt = ''; refs.alternador.appendChild(im); }
    var meio = el('div', 'ewc-cart__alternador-meio');
    var topoA = el('div', 'ewc-cart__alternador-topo');
    topoA.appendChild(el('span', 'ewc-cart__alternador-titulo', a.titulo || ''));
    var precoA = linhaA ? linhaA.final_line_price : null;
    if (precoA == null && a.handle) {
      var pa = produtoPronto[a.handle];
      if (pa) { var va = (pa.variants || []).filter(function (x) { return String(x.id) === String(a.variante_id); })[0] || pa.variants[0]; if (va) precoA = va.price; }
      else api.produto(a.handle).then(function () { if (carrinho === c) renderAlternador(c); });
    }
    topoA.appendChild(el('span', 'ewc-cart__alternador-preco', precoA != null ? dinheiro(precoA) : ''));
    meio.appendChild(topoA);
    if (a.descricao) meio.appendChild(el('p', 'ewc-cart__alternador-desc', a.descricao));
    refs.alternador.appendChild(meio);
    var chave = el('span', 'ewc-cart__chave' + (linhaA ? ' is-on' : ''));
    chave.appendChild(el('span', 'ewc-cart__chave-bola'));
    var caixa = el('input'); caixa.type = 'checkbox'; caixa.checked = !!linhaA; caixa.className = 'ewc-cart__chave-campo';
    caixa.addEventListener('change', function () {
      if (ocupado) { caixa.checked = !caixa.checked; return; }
      ocupado = true;
      var p = linhaA ? api.change(linhaA.key, 0)
                     : api.add([{ id: parseInt(a.variante_id, 10), quantity: 1, properties: { _ewc_upsell: '1' } }]).then(api.carrinho);
      p.then(render).catch(function () {}).then(function () { ocupado = false; });
    });
    refs.alternador.appendChild(caixa);
    refs.alternador.appendChild(chave);
  }

  /* Cupom: a Shopify aplica pela rota /discount/CODIGO, que volta pro carrinho. */
  function aplicarCupom() {
    var codigo = (refs.cupomInput.value || '').trim();
    if (!codigo) return;
    var url = cfg.raiz + 'discount/' + encodeURIComponent(codigo) + '?redirect=' + encodeURIComponent(cfg.raiz + 'cart');
    fetch(url, { credentials: 'same-origin' }).then(atualizar).catch(function () {});
  }

  /* ------------------------------------------------------------ ações */
  function atualizar() { return api.carrinho().then(render).catch(function () {}); }
  function mudar(chave, qtd) {
    if (ocupado) return; ocupado = true;
    api.change(chave, qtd).then(render).catch(function () {}).then(function () { ocupado = false; });
  }
  function adicionarUpsell(btn) {
    var vid = parseInt(btn.getAttribute('data-ewc-variante') || '0', 10); if (!vid || ocupado) return;
    ocupado = true; btn.disabled = true;
    api.add([{ id: vid, quantity: 1, properties: { _ewc_upsell: '1' } }]).then(atualizar).catch(function () {}).then(function () { ocupado = false; btn.disabled = false; });
  }
  var brindeOcupado = false;
  function brindeAutomatico(c) {
    var b = cfg.brinde; if (!b || !b.variante_id || !b.limiar || brindeOcupado) return;
    var limiar = Math.round(b.limiar * 100);
    var linhasBrinde = c.items.filter(ehBrinde);
    var total = principais(c).reduce(function (s, i) { return s + i.final_line_price; }, 0);
    var elegivel = total >= limiar && principais(c).length > 0;
    var ss = window.sessionStorage;
    function guardar(k, v) { try { v == null ? ss.removeItem(k) : ss.setItem(k, v); } catch (e) {} }
    function ler(k) { try { return ss.getItem(k); } catch (e) { return null; } }
    if (elegivel && !linhasBrinde.length && !ler('ewcBrindeRemovido')) {
      brindeOcupado = true;
      api.add([{ id: parseInt(b.variante_id, 10), quantity: 1, properties: { _ewc_gift: '1' } }])
        .then(function () { guardar('ewcBrindeAdicionado', '1'); return atualizar(); }).catch(function () {}).then(function () { brindeOcupado = false; });
    } else if (!elegivel && linhasBrinde.length) {
      brindeOcupado = true;
      api.change(linhasBrinde[0].key, 0).then(function (nc) { guardar('ewcBrindeAdicionado', null); render(nc); }).catch(function () {}).then(function () { brindeOcupado = false; });
    } else if (elegivel && !linhasBrinde.length && ler('ewcBrindeAdicionado')) {
      guardar('ewcBrindeRemovido', '1'); guardar('ewcBrindeAdicionado', null);   // o cliente tirou de propósito
    } else if (linhasBrinde.length && linhasBrinde[0].quantity > 1) {
      brindeOcupado = true;
      api.change(linhasBrinde[0].key, 1).then(render).catch(function () {}).then(function () { brindeOcupado = false; });
    }
  }
  function ligarTimer() {
    if (!cfg.timer_segundos) { refs.timer.textContent = ''; return; }
    var chave = 'ewcTimerInicio', inicio;
    try { inicio = parseInt(sessionStorage.getItem(chave) || '0', 10); } catch (e) { inicio = 0; }
    if (!inicio) { inicio = Date.now(); try { sessionStorage.setItem(chave, String(inicio)); } catch (e) {} }
    function tique() {
      var resta = Math.max(0, cfg.timer_segundos - Math.floor((Date.now() - inicio) / 1000));
      var m = Math.floor(resta / 60), s = resta % 60;
      refs.timer.textContent = (m < 10 ? '0' : '') + m + ':' + (s < 10 ? '0' : '') + s;
      if (resta === 0) {
        // zerou: começa de novo, senão a gaveta fica com 00:00 parado na tela
        inicio = Date.now();
        try { sessionStorage.setItem(chave, String(inicio)); } catch (e) {}
      }
    }
    tique(); if (!relogio) relogio = setInterval(tique, 1000);
  }
  function atualizarContadores(n) {
    var sel = SEL.contadores + (cfg.adaptador.contadores ? ',' + cfg.adaptador.contadores : '');
    document.querySelectorAll(sel).forEach(function (e) {
      if (raiz.contains(e)) return;
      if (/^\s*\d*\s*$/.test(e.textContent)) e.textContent = String(n);
      else e.textContent = e.textContent.replace(/\d+/, String(n));
    });
  }

  /* ------------------------------------------------------------ abrir / fechar */
  function abrir() {
    if (aberto) return;
    aberto = true; raiz.hidden = false; raiz.setAttribute('aria-hidden', 'false');
    requestAnimationFrame(function () { raiz.classList.add('is-open'); });
    document.documentElement.classList.add('ewc-cart-aberto');
    atualizar();
    document.dispatchEvent(new CustomEvent('ewc:cart:open'));
  }
  function fechar() {
    if (!aberto) return;
    aberto = false; raiz.classList.remove('is-open'); document.documentElement.classList.remove('ewc-cart-aberto');
    setTimeout(function () { if (!aberto) { raiz.hidden = true; raiz.setAttribute('aria-hidden', 'true'); } }, 300);
  }

  /* ------------------------------------------------------------ adaptador */
  function esconderNativa() {
    var css = document.createElement('style');
    css.setAttribute('data-ewc-cart', 'esconde-nativa');
    var sel = SEL.gaveta_nativa + (cfg.adaptador.gaveta_nativa ? ',' + cfg.adaptador.gaveta_nativa : '');
    css.textContent = sel + '{display:none !important;visibility:hidden !important}';
    document.head.appendChild(css);
  }
  function instalarGatilhos() {
    var sel = SEL.gatilhos + (cfg.adaptador.gatilhos ? ',' + cfg.adaptador.gatilhos : '');
    document.addEventListener('click', function (ev) {
      var alvo = ev.target.closest && ev.target.closest(sel);
      if (!alvo || raiz.contains(alvo) || alvo.hasAttribute('data-ewc-skip')) return;
      var href = alvo.getAttribute('href') || '';
      if (href && !/\/cart(\/|\?|$)/.test(href)) return;
      ev.preventDefault(); ev.stopPropagation(); ev.stopImmediatePropagation();
      abrir();
    }, true);
  }
  function itensDoFormulario(form) {
    var fd = new FormData(form), id = parseInt(fd.get('id') || '0', 10), qtd = parseInt(fd.get('quantity') || '1', 10) || 1, props = {};
    fd.forEach(function (v, k) { var m = /^properties\[(.+)\]$/.exec(k); if (m && v !== '') props[m[1]] = v; });
    if (!id) return null;
    var item = { id: id, quantity: qtd }; if (Object.keys(props).length) item.properties = props;
    var plano = fd.get('selling_plan'); if (plano) item.selling_plan = plano;
    return [item];
  }
  function instalarFormularios() {
    var ignorar = cfg.adaptador.ignorar_formularios;
    document.addEventListener('submit', function (ev) {
      var form = ev.target;
      if (!form || !/\/cart\/add/.test(form.getAttribute('action') || '')) return;
      if (raiz.contains(form) || form.hasAttribute('data-ewc-skip') || form.hasAttribute('data-ewc-bundle-form')) return;
      if (ignorar && form.closest(ignorar)) return;
      var itens = itensDoFormulario(form); if (!itens) return;
      ev.preventDefault(); ev.stopPropagation(); ev.stopImmediatePropagation();
      var btn = form.querySelector('[type="submit"],button[name="add"]'); if (btn) btn.disabled = true;
      api.add(itens).then(function () { if (cfg.adaptador.abrir_ao_adicionar !== false) abrir(); else atualizar(); })
        .catch(function () { form.submit(); })
        .then(function () { if (btn) btn.disabled = false; });
    }, true);
  }
  function vigiarRede() {
    // o tema pode adicionar por JavaScript próprio (sem submit): ver a rede é o único gancho que vale em todo tema
    var fetchOriginal = window.fetch;
    if (typeof fetchOriginal === 'function' && !fetchOriginal._ewc) {
      var f = function (entrada, opts) {
        var url = typeof entrada === 'string' ? entrada : (entrada && entrada.url) || '';
        var p = fetchOriginal.apply(this, arguments);
        if (/\/cart\/(add|change|update|clear)(\.js)?(\?|$)/.test(url) && !(opts && opts.headers && opts.headers['X-Ewc'])) {
          p.then(function (r) {
            if (!r.ok) return;
            if (/\/cart\/add/.test(url) && cfg.adaptador.abrir_ao_adicionar !== false) abrir(); else if (aberto) atualizar();
          }).catch(function () {});
        }
        return p;
      };
      f._ewc = true; window.fetch = f;
    }
    var abrirXhr = XMLHttpRequest.prototype.open;
    XMLHttpRequest.prototype.open = function (m, url) {
      if (/\/cart\/(add|change|update|clear)(\.js)?(\?|$)/.test(String(url))) {
        this.addEventListener('load', function () {
          if (this.status >= 200 && this.status < 300) { if (/\/cart\/add/.test(String(url)) && cfg.adaptador.abrir_ao_adicionar !== false) abrir(); else if (aberto) atualizar(); }
        });
      }
      return abrirXhr.apply(this, arguments);
    };
  }

  /* ------------------------------------------------------------ início */
  function iniciar() {
    raiz = document.getElementById('ewc-cart-root'); if (!raiz) return;
    cfg = lerConfig();
    montar(); esconderNativa(); instalarGatilhos(); instalarFormularios(); vigiarRede();
    document.addEventListener('ewc:cart:added', function () { abrir(); });
    document.addEventListener('cart:refresh', function () { if (aberto) atualizar(); });
    window.addEventListener('pageshow', function () { ocupado = false; brindeOcupado = false; if (aberto) atualizar(); else api.carrinho().then(function (c) { atualizarContadores(c.item_count); }).catch(function () {}); });
    api.carrinho().then(function (c) { carrinho = c; atualizarContadores(c.item_count); brindeAutomatico(c); }).catch(function () {});
    window.EwcCart = { abrir: abrir, fechar: fechar, atualizar: atualizar, carrinho: function () { return carrinho; }, config: function () { return cfg; } };
  }
  try {
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', iniciar); else iniciar();
  } catch (e) { /* falha aberto */ }
})();
